'use client';
import React, { useState } from 'react';
import { MimaButton, MimaInput, MimaText, MimaToastUtil, PageLayout2 } from '@/components';
import styles from '@/assets/styles/pages/contact/Contact.module.scss';
import { useForm, SubmitHandler } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { phoneRegExp } from '@/utils/utils';
import constant from '@/utils/constant';
import { IContactFormRequest } from '@/interfaces';
import { SupportController } from '@/controllers';
import { FaEnvelope, FaLocationDot, FaPhone, FaFacebook, FaXTwitter, FaThreads } from 'react-icons/fa6';
import { FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa';

const ContactUs = () => {
  const [loading, setLoading] = useState(false);

  const validationSchema = z.object({
    email: z.string().min(1, { message: 'Email is required' }).email({ message: 'Please enter a valid email' }),
    name: z.string().min(1, { message: 'Enter Name' }),
    title: z.string().min(1, { message: 'Enter a message title' }),
    message: z.string().min(1, { message: 'Enter a message' }),
    mobile: z
      .string()
      .min(1, { message: 'Phone number is required' })
      .refine((value) => phoneRegExp.test(value), {
        message: 'Phone number is not valid',
      }),
  });

  // const {
  //   control,
  //   handleSubmit,
  //   formState: { errors, touchedFields },
  // } = useForm<IContactFormRequest>({ resolver: zodResolver(validationSchema), mode: 'onBlur' });

  const {
    control,
    handleSubmit,
    formState: { errors, touchedFields },
  } = useForm<IContactFormRequest>({
    resolver: zodResolver(validationSchema),
    mode: 'onBlur',
  });

  const onSubmit: SubmitHandler<IContactFormRequest> = async (values) => {
    const payload = values;
    setLoading(true);
    const { status, errorMessage } = await SupportController.contactUs(payload);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      setLoading(false);
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
  };

  return (
    <PageLayout2>
      <MimaText variant="h4Bold" align="center" mt={5} mb={3}>
        Contact Us
      </MimaText>
      <section className={styles.contactSection}>
        <div className={styles.contact}>
          <div className={styles.contact__mode}>
            <FaLocationDot className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Address
            </MimaText>
            <MimaText variant="body">
              1021 E LINCOLNWAY SUITE #7293, CHEYENNE, WYOMING 82001, UNITED STATES
              {/* 33 TE Williams Street, Lagos
              <br />
              Or
              <br />
              745 John Adams CT,
              <br />
              Fate Texas 75189 */}
            </MimaText>
          </div>
          {/* <div className={styles.contact__mode}>
            <FaPhone className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Phone
            </MimaText>
            <MimaText variant="body">
              +2348137567020 <br />
              +2348050439131
            </MimaText>
          </div> */}
          <div className={styles.contact__mode}>
            <FaEnvelope className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Email
            </MimaText>
            <MimaText variant="body">Hello@fash.style</MimaText>
          </div>
          <a className={styles.contact__mode} href="https://x.com/_fashcreatives" target="_blank" rel="noreferrer">
            <FaXTwitter className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Twitter
            </MimaText>
            <MimaText variant="body">@_fashcreatives</MimaText>
          </a>
          <a className={styles.contact__mode} href="https://www.facebook.com/profile.php?id=61559341057334" target="_blank" rel="noreferrer">
            <FaFacebook className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Facebook
            </MimaText>
            <MimaText variant="body">Mima</MimaText>
          </a>
          <a className={styles.contact__mode} href="https://www.instagram.com/_fashcreatives/" target="_blank" rel="noreferrer">
            <FaInstagram className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Instagram
            </MimaText>
            <MimaText variant="body">@_fashcreatives</MimaText>
          </a>
          <a className={styles.contact__mode} href="https://www.tiktok.com/@_fashcreatives" target="_blank" rel="noreferrer">
            <FaTiktok className={styles.icon} />
            <MimaText variant="bodyBold" mt={1} mb={1}>
              Tiktok
            </MimaText>
            <MimaText variant="body">@_fashcreatives</MimaText>
          </a>
        </div>
        <div className={styles.form}>
          <MimaText variant="subtitleBold" color="var(--color-primary-2)" align="center" mb={3}>
            Drop a line
          </MimaText>
          <MimaText variant="smallBold" align="center" mb={4}>
            Feel free to contact us if you have any further question or concern
          </MimaText>

          <form onSubmit={handleSubmit(onSubmit)}>
            <MimaInput
              name="name"
              placeholder="Enter your Name"
              error={errors.name}
              touched={touchedFields.name}
              variant="exchange"
              labelTitle="Your Name"
              width={38}
              mb={4}
              defaultValue=""
              control={control}
            />
            <MimaInput
              name="email"
              placeholder="Enter your email"
              error={errors.email}
              touched={touchedFields.email}
              variant="exchange"
              labelTitle="Your Email"
              width={38}
              mb={4}
              defaultValue=""
              control={control}
            />
            <MimaInput
              name="mobile"
              placeholder="Enter your Phone No"
              error={errors.mobile}
              touched={touchedFields.mobile}
              variant="exchange"
              labelTitle="Your phone number"
              width={38}
              mb={4}
              defaultValue=""
              control={control}
            />
            <MimaInput
              name="title"
              placeholder="Enter your message title"
              error={errors.title}
              touched={touchedFields.title}
              variant="exchange"
              width={38}
              mb={4}
              defaultValue=""
              control={control}
            />
            <MimaInput
              name="message"
              error={errors.message}
              touched={touchedFields.message}
              variant="exchange"
              placeholder="Enter your message"
              width={38}
              mb={4}
              defaultValue=""
              control={control}
            />

            <MimaButton loading={loading} title="Send message" type="submit" mb={4} />
          </form>
        </div>
      </section>
    </PageLayout2>
  );
};

export default ContactUs;
